import fr from 'facet-rest';

export const CuratedContentArticleTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('uploadImage', {
    ordinal: 0,
    _column: {
      action: {
        name: 'uploadImageAction',
      },
    },
  })
  .nameOverride('name', { ordinal: 1 })
  .nameOverride('contentUrl', { ordinal: 4 })
  .nameOverride('minAge', { ordinal: 5 })
  .nameOverride('maxAge', { ordinal: 6 })
  .nameOverride('targetedHouseholdStatus', { ordinal: 7 })
  .nameOverride('publishedDate', { ordinal: 8 })
  .nameOverride('excerpt', { hidden: true })
  .nameOverride('topicId', { hidden: true })
  .nameOverride('lifeMilestoneId', { hidden: true })
  .done();

export const CuratedContentArticleEditOverride = fr.metaOverride()
  .nameOverride('name', { ordinal: 0 })
  .nameOverride('contentUrl', { ordinal: 3 })
  .nameOverride('minAge', { ordinal: 4 })
  .nameOverride('maxAge', { ordinal: 5 })
  .nameOverride('targetedHouseholdStatus', { ordinal: 6 })
  .nameOverride('publishedDate', { ordinal: 7 })
  .nameOverride('uploadImage', { hidden: true })
  .done();
